import { render, staticRenderFns } from "./lawsifynew.vue?vue&type=template&id=7492f834&"
import script from "./lawsifynew.vue?vue&type=script&lang=js&"
export * from "./lawsifynew.vue?vue&type=script&lang=js&"
import style0 from "./lawsifynew.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports